import StudioLanding from "@/pages/studio/StudioLanding";

export default function Home() {
  return <StudioLanding />;
}
